import { getIsProduction } from "@faire/help-center-utils/serialized-data/getEnvName";

export const buildMobileChatUrl = (
  issueType: string,
  brandOrderToken: string | undefined
) => {
  const domain = buildDomain();
  const issueTypeParam = `issue-type=${issueType}`;
  const brandOrderTokenParam = brandOrderToken
    ? `&brand-order-token=${brandOrderToken}`
    : "";
  const redirectUrl = `${domain}://show-chat?${issueTypeParam}${brandOrderTokenParam}`;
  return redirectUrl;
};

const buildDomain = () => {
  const isProduction = getIsProduction();
  const environment = isProduction ? "" : "staging.";
  const domain = `com.faire.retailer.${environment}support-chat`;
  return domain;
};
